(() => {
  const drawChart = (chart) => {
    const svg = chart.querySelector('svg');
    let points = [];
    try {
      points = JSON.parse(chart.dataset.points || '[]');
    } catch (_error) {
      points = [];
    }
    const validPoints = points.filter((point) => point.date && Number.isFinite(Number(point.price)));
    const values = validPoints.map((point) => Number(point.price));

    if (!svg || values.length < 2) {
      chart.classList.add('sg-price-history--empty');
      return;
    }

    const width = 360;
    const height = 150;
    const inset = 8;
    const minimum = Math.min(...values);
    const maximum = Math.max(...values);
    const range = maximum - minimum || 1;
    const plottedPoints = values.map((value, index) => {
      const x = inset + (index / (values.length - 1)) * (width - inset * 2);
      const y = height - inset - ((value - minimum) / range) * (height - inset * 2);
      return `${x.toFixed(2)},${y.toFixed(2)}`;
    }).join(' ');

    svg.innerHTML = `
      <line x1="0" y1="149" x2="360" y2="149" class="sg-price-history__axis"></line>
      <polyline points="${plottedPoints}" class="sg-price-history__line"></polyline>
    `;

    const locale = document.documentElement.lang || 'en';
    const currency = chart.dataset.currency || 'EUR';
    const money = new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: 2 });
    const date = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', year: 'numeric' });
    const parseDate = (value) => {
      const parsed = new Date(`${value}T00:00:00`);
      return Number.isNaN(parsed.getTime()) ? value : date.format(parsed);
    };
    chart.querySelector('.sg-price-history__maximum').textContent = money.format(maximum);
    chart.querySelector('.sg-price-history__minimum').textContent = money.format(minimum);
    chart.querySelector('.sg-price-history__start').textContent = parseDate(validPoints[0].date);
    chart.querySelector('.sg-price-history__end').textContent = parseDate(validPoints.at(-1).date);
  };

  const initialise = (root = document) => root.querySelectorAll('.sg-price-history').forEach(drawChart);

  const initialiseAnalytics = () => {
    const guide = document.querySelector('[data-sg-analytics-root]');
    if (!guide || guide.dataset.sgAnalyticsInitialised === 'true') return;
    guide.dataset.sgAnalyticsInitialised = 'true';

    const articleData = {
      guide_type: guide.dataset.guideType || 'structured_guide',
      guide_source: guide.dataset.guideSource || 'structured_article_guide',
      article_id: guide.dataset.articleId || '',
      article_handle: guide.dataset.articleHandle || '',
      article_title: guide.dataset.articleTitle || '',
      article_url: guide.dataset.articleUrl || window.location.pathname,
      page_location: window.location.href,
    };
    const pendingAdds = new Map();

    const productData = (element) => {
      const card = element?.closest('[data-sg-product-card]');
      if (!card) return {};
      return {
        product_id: card.dataset.productId || '',
        variant_id: card.dataset.variantId || '',
        product_handle: card.dataset.productHandle || '',
        product_title: card.dataset.productTitle || '',
        product_url: card.dataset.productUrl || '',
        value: Number(card.dataset.priceCents || 0) / 100,
        currency: card.dataset.currency || '',
      };
    };

    const publishEvent = (eventName, eventData = {}) => {
      const payload = {
        ...articleData,
        ...eventData,
      };
      if (typeof window.tcgkingTrackArticleEvent === 'function') {
        window.tcgkingTrackArticleEvent(eventName, payload);
      }
      if (!window.Shopify?.analytics?.publish) return;
      try {
        const result = window.Shopify.analytics.publish(`tcgking:${eventName}`, payload);
        if (result?.catch) result.catch(() => {});
      } catch (_error) {
        // Analytics must never interrupt navigation or commerce actions.
      }
    };

    guide.addEventListener('click', (event) => {
      const target = event.target.closest('[data-sg-action]');
      if (!target || !guide.contains(target)) return;
      const action = target.dataset.sgAction;

      if (action === 'product_view') {
        publishEvent('article_product_view', {
          ...productData(target),
          click_target: target.dataset.sgPlacement || 'product_link',
        });
      } else if (action === 'related_article') {
        publishEvent('article_related_click', {
          placement: target.dataset.sgPlacement || '',
          destination_title: target.dataset.destinationTitle || target.textContent.trim(),
          destination_url: target.getAttribute('href') || '',
        });
      } else if (action === 'checklist_open') {
        publishEvent('article_checklist_open', {
          placement: target.dataset.sgPlacement || '',
          destination_url: target.getAttribute('href') || '',
        });
      } else if (action === 'jump_to_set') {
        publishEvent('article_jump_to_set', {
          set_name: target.dataset.sgSet || target.textContent.trim(),
          destination_anchor: target.getAttribute('href') || '',
        });
      } else if (action === 'collection') {
        publishEvent('article_collection_click', {
          ...productData(target),
          placement: target.dataset.sgPlacement || '',
          destination_title: target.dataset.destinationTitle || target.textContent.trim(),
          destination_url: target.getAttribute('href') || '',
        });
      }
    });

    document.addEventListener('click', (event) => {
      const collectionLink = event.target.closest('.rcb3__btn');
      if (!collectionLink) return;
      publishEvent('article_collection_click', {
        destination_title: collectionLink.textContent.trim(),
        destination_url: collectionLink.getAttribute('href') || '',
      });
    });

    guide.querySelectorAll('product-form form').forEach((form) => {
      form.addEventListener('submit', () => {
        const submitButton = form.querySelector('[data-sg-action="add_to_cart"]');
        const details = productData(submitButton || form);
        if (details.variant_id) pendingAdds.set(String(details.variant_id), details);
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.source !== 'product-form') return;
        const variantId = String(event.productVariantId || '');
        const details = pendingAdds.get(variantId);
        if (!details) return;
        pendingAdds.delete(variantId);
        publishEvent('article_add_to_cart', details);
      });
      subscribe(PUB_SUB_EVENTS.cartError, (event) => {
        if (event?.source === 'product-form') pendingAdds.delete(String(event.productVariantId || ''));
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialise();
      initialiseAnalytics();
    }, { once: true });
  } else {
    initialise();
    initialiseAnalytics();
  }
})();
